<template>
  <div>
    <div class="modal is-active">
      <div @click="close" class="modal-background"></div>
      <div class="modal-content">
        <div class="card">
          <div class="card-content">
            <div class="content">
              <ul v-if="preferences.length > 0">
                <li class="list-item" v-for="(pref, key) in preferences" v-bind:key="key">
                  <p>Name: {{ pref.name }}</p>
                  <p>Keyword: {{ pref.keyword }} </p>
                </li>
              </ul>
              <div v-else>
                No preferences selected by user
              </div>
            </div>
          </div>
        </div>
      </div>
      <button @click="close" class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['preferences'],
  methods: {
    close() {
      this.$emit("close")
    },
  },
}
</script>

<style>
.list-item {
  margin-bottom: 5px;
  border-bottom: 1px solid #f1f1f1;
}
</style>

<style scoped>
.update {
  cursor: pointer;
}

.columns {
  align-items: center;
}

/* Match spacing style used between action buttons in the list (uses a non-breaking space ~ 4px default). */
.btn-pair {
  display: inline-flex;
  column-gap: 0.5rem; /* Bulma default spacing between inline controls approximates NBSP width; adjust as needed */
}

/* Push the download button to the far right within the column */
.column:last-child {
  display: flex;
  justify-content: flex-end;
}

/* Make all action buttons the same width */
.action-btn { 
  min-width: 8rem; /* Increased to accommodate "unarchive" text */
  width: 8rem; /* Fixed width for all buttons */
  text-align: center;
}

/* Keep action buttons on a single line within the cell on wider screens */
td:last-child{
  white-space: nowrap;
}

/* Make id and type columns narrow to free horizontal space */
th:first-child, td:first-child{ width: 1%; white-space: nowrap; }
th:nth-child(4), td:nth-child(4){ width: 1%; white-space: nowrap; }

/* Slightly reduce font-size and padding inside the table to fit more content */
.table{ font-size: 0.9rem; }
.table .button.is-small{ padding-left: 0.6em; padding-right: 0.6em; }

/* Make the button group spacing minimal inside action cell */
td:last-child .button + .button{ margin-left: 0.25rem; }

/* RESPONSIVE: improve button lists on small screens */
@media (max-width: 768px) {
  /* Header button list: stack and left-align on mobile */
  .column:last-child {
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
  .btn-pair {
    flex-wrap: wrap;
    row-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .btn-pair .button {
    width: 100%; /* full-width buttons for easier tapping */
  }

  /* Reset table display and allow normal table behavior on small screens */
  .table {
    display: table;
    overflow-x: visible;
  }

  /* Row action buttons: stack vertically on small screens */
  td:last-child {
    white-space: normal !important; /* Override the nowrap */
    min-width: 120px; /* Ensure enough width for stacked buttons */
  }
  
  /* Create a flex container for the buttons within each cell */
  td:last-child {
    padding: 0.5rem;
  }
  
  td:last-child .button {
    display: block;
    width: 100%;
    margin: 0 0 0.25rem 0 !important;
    min-width: auto;
  }
  
  td:last-child .button:last-child {
    margin-bottom: 0 !important;
  }
}

/* Slightly tighter on extra small screens */
@media (max-width: 480px) {
  .table { 
    font-size: 0.85rem; 
  }
  .table .button.is-small{ 
    padding-left: 0.5em; 
    padding-right: 0.5em; 
    font-size: 0.75rem;
  }
  
  /* Make the action column wider on very small screens */
  td:last-child {
    min-width: 100px;
    width: auto;
  }
}
</style>